'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @typedef {object} HttpClientResponse
 * @property {*} data - response payload
 * @property {number} status - Http status code
 * @property {string} statusText - Http status message
 * @property {object} headers - key-value object with Http response headers
 */

/**
 * Transforms the current HTTP library's response object into our own scheme.
 *
 * @param {object} axiosResponse - response object from the Axios API. {@see https://github.com/mzabriskie/axios#response-schema}
 * @returns {HttpClientResponse}
 */
var createResponse = function createResponse(axiosResponse) {
  return {
    data: axiosResponse.data,
    status: axiosResponse.status,
    statusText: axiosResponse.statusText,
    headers: axiosResponse.headers
  };
};

/**
 * Low-level DoorDash HTTP Client.
 * This class is meant to be wrapped.
 */
var createFetch = function createFetch(_ref) {
  var baseUrl = _ref.baseUrl;

  var http = _axios2.default.create({
    baseURL: baseUrl
  });

  /**
   * Perform a Http request.
   *
   * @param {string} url
   * @returns {Promise.<HttpClientResponse>}
   */
  return function (url, _ref2) {
    var method = _ref2.method,
        withCredentials = _ref2.withCredentials,
        headers = _ref2.headers,
        data = _ref2.data;
    return http.request({
      url: url,
      method: method,
      withCredentials: withCredentials,
      headers: headers,
      data: data
    }).then(createResponse);
  };
};

exports.default = createFetch;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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